import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { Link, useLocation } from "react-router-dom";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { LoadingScreen } from "../../UiComponents/LoadingComponent";
import { sbaAxios } from "../../utils/sbaAxios";
import {
  getContactsDetailsAction,
  getContactsHeaderAction,
} from "../../actions/contactsAction";
import { UrlPath } from "../../../config/routeConfig";
import {
  getGetEnumeration,
  updateContactHeader,
  deleteContactImage,
  getCustomSettings,
  updateCustomSettings,
  getUserPageAccess,
} from "../../../config/apiConfig";
import { TopBar } from "../../shared/topBar/TopBar";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Contacts } from "./contactInfo/Contacts";
import { Relationships } from "./contactInfo/Relationships";
//import { Tasks } from "./contactInfo/Tasks";
import { Documents } from "./contactInfo/Documents";
import { Account } from "./contactInfo/Account";
import { Reporting } from "./contactInfo/Reporting";
import { Tasks } from "./contactInfo/Tasks";
import { PortalAccess } from "./contactInfo/PortalAccess";
import { ClientProfile } from "./contactInfo/ClientProfile";
import { Badge, Col, Image } from "react-bootstrap";
import SampleProfile from "./sampleImage/ProfileImage.png";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { ToastContainer, toast } from "react-toastify";
import { SBADropDown } from "../../UiComponents/SBADropDown";
import { SBNotify } from "../../utils/sbNotify";
import { AgGridReact } from "ag-grid-react";
import "../../investor/investor.css";
import Modal from "react-bootstrap/Modal";
import { Activities } from "./contactInfo/Activities";
export const Details = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const params = useParams();
  const locationData = useLocation();

  const Gstate = useSelector((state) => state) || {};

  const isEditable = Gstate.authorizationData.isEditable;

  const ContactsHeader = Gstate?.Contacts.ContactsHeader || [];
  const ContactDetails = Gstate?.Contacts.ContactDetails || [];
  const selectedTypeValue=Gstate?.Contacts?.ContactInfo?.ContactInfo?.ContactTypeId || 1 ;


  const TotalTabs = useRef();
  const selectedTabRef = useRef();
  const [render, setRender] = useState(true);
  const [loading, setLoading] = useState(true);
  const [dataUri, setDataUri] = useState("");
  const [showDrawer, setshowDrawer] = useState(false);
  const [base64Data, setBase64Data] = useState(null);
  const [isActive, setIsActive] = useState("");
  const [investmentStatusData, setInvestmentStatusData] = useState([]);
  const [investmentStatusValue, setInvestmentStatusValue] = useState({});
  const [showCustomButton, setShowCustomButton] = useState(false);
  const [showEditButton, setShowEditButton] = useState(false);
  const [selecttab, SetSelecttab] = useState([]);
  const [defaultcol, setDefaultCol] = useState([]);
  const [selectedcol, setSelectedCol] = useState([]);
  const [selecteddrop, setSelecteddrop] = useState([]);
  const [defaultvalue, Setdefaultvalue] = useState([]);
  const [isContactHovered, setIsContactHovered] = useState(false);
  const [isCompanyHovered,setIsCompanyHovered]= useState(false);
  const [defaulttab, SetDefaulttab] = useState({
    DisplayName: "Contact",
    SortOrder: 1,
  });
  const [selectedTab, setSelectedTab] = useState(null);
  const [investorPremission,setInvestorPersmission]=useState(false);
  const [investmentPremission,setInvestmentPersmission]=useState(false);
  const loadPermission=async()=>{
    await sbaAxios({ url: `${getUserPageAccess}?keyName=ContactInvestorAccess` }).then(res=>setInvestorPersmission(res));
    await sbaAxios({ url: `${getUserPageAccess}?keyName=ContactInvestmentAccess` }).then(res=>setInvestmentPersmission(res))  
  };


  const queryParams = new URLSearchParams(locationData.search);
  const paramValue = queryParams.get('ContactTypeId') || selectedTypeValue; 
  const showTab=paramValue!=2;
 
  const getContactInvestmentStatus = () => {
    sbaAxios({
      url: `${getGetEnumeration}ContactInvestmentStatus`,
      method: "get",
    }).then((response) => {
      setInvestmentStatusData(response);
    });
  };
  useEffect(() => {
    const defaultItem = defaultvalue.find(item => item.IsDefault === true);
    SetDefaulttab({
      DisplayName: defaultItem?.DisplayName || "Contact",
      SortOrder: defaultItem?.SortOrder || 1,
    });
      setSelectedTab(locationData?.state?.tab || defaultItem?.ColumnName);
  }, [defaultvalue]);

  useEffect(() => {
    document.title = `Investor Details`;
    // dispatch(getContactsDetailsAction(params.ContactId));
    dispatch(getContactsHeaderAction(params.ContactId));
    getContactInvestmentStatus();
    getCustomSetting();
    loadPermission();
  }, [render]);
  useEffect(() => {
    ContactsHeader && ContactDetails && setLoading(false);
  }, [ContactsHeader, ContactDetails]);
  useEffect(() => {
    if (ContactsHeader) {
      setBase64Data(ContactsHeader.ContactImageFile);
      setIsActive(ContactsHeader.IsActive);
      setInvestmentStatusValue({
        EnumName: ContactsHeader.ContactInvestmentStatusName,
        EnumValue: ContactsHeader.ContactInvestmentStatusId,
      });
    }
  }, [ContactsHeader]);

  let Level = [{ BreadCrumb: paramValue===1?"Investors > ":"CRM >", Routes: `${UrlPath.Investor}` }];

  Level = loading
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `${ContactsHeader.ContactName}`,
          Routes: `${UrlPath.InvestorDetails}${params.ContactId}`,
        },
      ];

  useEffect(() => {
    const hexString =
      ContactsHeader.ContactImageFile !== null
        ? ContactsHeader.ContactImageFile
        : "";

    if (hexString !== "") {
      const base64String = hexString;
      setDataUri(`data:image/png;base64,${base64String}`);
    } else {
      setDataUri(null);
    }
  }, [ContactsHeader]);

  const headerEditClick = (data) => {
    let value = data;
    if(isEditable !== false){
    if (value === "Edit") {
      setShowCustomButton(false);
      setShowEditButton(true);
    } else if (value === "custom") {
      setShowEditButton(false);
      setShowCustomButton(true);
    }

    setshowDrawer(true);
  }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function () {
        if (reader.result) {
          const arrayBuffer = reader.result;
          const base64String = arrayBufferToBase64(arrayBuffer);
          setBase64Data(base64String);
          if (base64String) {
            setDataUri(`data:image/png;base64,${base64String}`);
          }
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const arrayBufferToBase64 = (arrayBuffer) => {
    const binary = [];
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary.push(String.fromCharCode(bytes[i]));
    }
    return btoa(binary.join(""));
  };

  const handleDeleteImage = () => {
    deleteImage();
    setRender(!render);
    getContactsHeaderAction();
  };

  const deleteImage = () => {
    const imageId = ContactsHeader.ContactImageId;
    const contactId = ContactsHeader.ContactId;

    const response = sbaAxios({
      url: `${deleteContactImage}${imageId},${contactId}`,
      method: "get",
    });
    if (response) {
      SBNotify({ type: "success", Msg: "Image Deleted Successfully" });
    } else {
      SBNotify({ type: "warning", Msg: "Failed to Delete" });
    }
  };

  const toggleSwitch = () => {
    setIsActive(!isActive);
  };

  const statusDataChange = (e) => {
    setInvestmentStatusValue({
      EnumName: e.value.EnumName,
      EnumValue: e.value.EnumValue,
    });
  };

  const closeDrawer = () => {
    setshowDrawer(false);
    setShowEditButton(false);
    setShowCustomButton(false);
    setRender(!render);
  };

  const UpdateContactHeader = async () => {
    let saveSuccess = true;
    let errorMsg = [];
    const data = {
      contactId: ContactsHeader.ContactId,
      contactImageId:
        ContactsHeader.ContactImageId !== 0
          ? ContactsHeader.ContactImageId
          : null,
      contactImageFile: base64Data,
      isActive: isActive,
      contactInvestmentStatusId: investmentStatusValue.EnumValue,
      modifiedBy: 0,
    };

    if (saveSuccess) {
      const response = await sbaAxios({
        url: `${updateContactHeader}`,
        method: "post",
        data: data,
      });
      if (response > 0) {
        SBNotify({ type: "success", Msg: "Updated Successfully" });
        setRender(!render);
        setshowDrawer(false);
      } else {
        SBNotify({ type: "warning", Msg: "Failed" });
      }
    }
  };
  const navigateToAddNewContact = () => {
    history(`${UrlPath.InvestorDetailsEdit}${0}`);
  };

  const navigateToAddNewCompany = () => {
    history(`${UrlPath.CompanyDetailsEdit}${0}`);
  };
  const navigateToAddNew = () => {
    history(`${UrlPath.InvestorAccountAdd}`);
  };
  const MaincolDef = [{ field: "DisplayName", headerName: "Available Tabs",flex:1 }];
   const selectcolDef = [{ field: "DisplayName", headerName: "Selected Tabs", flex: 1, rowDrag: true, }];
  const MainRowDoubleClicked = (e) => {
    SetSelecttab(e.value);
  };

  const selectedRowDoubleClicked = (e) => {
    SetSelecttab(e.value);
  };
    const updatecustomsetting = (data) => {    
        const defaultValue = data.map((item ) => {
            return { ...item, Isvisible: true};
        });
      const saveData = {
      componentId: 1014,
      componentUserSettingId: 0,
      userId: 0,
      customSettingsValue: JSON.stringify(defaultValue),
      customFilterValue: "{}",
      isGrid: true,
      componentname: "InvestorTabcustomize",
    };
    const response = sbaAxios({
      url: updateCustomSettings,
      method: "post",
      data: saveData,
    });

    if (response) {
      getCustomSetting();
    }
  };
    const getCustomSetting = async () => {
    let settingsValue;
    try {
      const response = await sbaAxios({
        url: `${getCustomSettings}${1014}`,
        method: "get",
      });
      if (response && response.CustomSettingsValue) {
        try {
          settingsValue = JSON.parse(response.CustomSettingsValue);
          setDefaultCol(settingsValue);
          Setdefaultvalue(settingsValue);
        } catch (parseError) {
          //console.error('Error parsing JSON:', parseError);
        }
      }
      if (settingsValue) {
        const filterData = settingsValue
          .filter((item) => item.Isvisible === true)
          .map((item) => ({
            ColumnName: item.ColumnName,
            DisplayName: item.DisplayName,
            SortOrder: item.SortOrder,
            Isvisible: item.Isvisible,
            IsDefault: item.IsDefault,
          }));

        setSelectedCol(filterData);
        if (filterData.length === 0) {
          updatecustomsetting(settingsValue);
        }
      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
    };
    const onRowDragEnd = (event) => {     
        const updatedRowData = [];
        event.api.forEachNodeAfterFilterAndSort((node) => {
            updatedRowData.push(node.data);
        });
        const contactItems = updatedRowData.filter(item => item.ColumnName === "Contacts");
        const nonContactItems = updatedRowData.filter(item => item.ColumnName !== "Contacts");   
        const remainstab = defaultvalue.filter((defaultItem) => {
            return !updatedRowData.some(item => item.ColumnName === defaultItem.ColumnName);
        });
        const newOrder = [
            ...contactItems.map((item, index) => ({
                ...item, Isvisible:true,
                SortOrder: index,
            })),
            ...nonContactItems.map((item, index) => ({
                ...item, Isvisible: true,
                SortOrder: contactItems.length + index,
            })),
            ...remainstab.map((item, index=+1) => ({
                ...item,
                SortOrder: contactItems.length + nonContactItems.length + index,
            })),
        ];

        Setdefaultvalue(newOrder);
    };
    const addTabs = (e) => {   
    const newTabs = TotalTabs.current.api.getSelectedRows();
    const updatevalue = defaultvalue?.map((item) =>
      item.ColumnName === newTabs[0].ColumnName
            ? { ...item, Isvisible: true }
        : item
    );
    Setdefaultvalue(updatevalue);
    if (
      !selectedcol.some((item) => item.ColumnName === newTabs[0].ColumnName)
    ) {
      const newdata = {
        ColumnName: newTabs[0].ColumnName,
        DisplayName: newTabs[0].DisplayName,
        Isvisible: newTabs[0].Isvisible,
        SortOrder: newTabs[0].SortOrder,
        IsDefault: newTabs[0].IsDefault,
      };
      setSelectedCol([...selectedcol, newdata]);
    }
  };
  const removeTabs = (e) => {
    const newTabs = selectedTabRef.current.api.getSelectedRows();
    const updatevalue = defaultvalue?.map((item) =>
      item.ColumnName === newTabs[0].ColumnName
        ? { ...item, Isvisible: false }
        : item
    );
    Setdefaultvalue(updatevalue);
    const newdata = selectedcol.filter(
      (item) => item.ColumnName !== newTabs[0].ColumnName
    );
    if (newdata) {
      setSelectedCol(newdata);
    }
  };
  const Addsave = async () => {     
    closeDrawer();
        if (defaultvalue) {           
        const saveData = {
        componentId: 1014,
        componentUserSettingId: 0,
        userId: 0,
        customSettingsValue: JSON.stringify(defaultvalue),
        customFilterValue: "{}",
        isGrid: true,
        componentname: "InvestorTabcustomize",
      };
      const response = await sbaAxios({
        url: updateCustomSettings,
        method: "post",
        data: saveData,
      });
      if (response.status === 200) {
        getCustomSetting();
        history(`${UrlPath.InvestorDetails}${params.ContactId}`);
      }
    }
  };
  const visibleTabs = defaultvalue.filter((item) => {

    if (showTab) {
      return (item.ColumnName === "Contacts"  || item.Isvisible === true);
    } else {
      return item.ColumnName === "Contacts" ;
    }
  });
  const handleTabClick = (selectedTab) => {
    setSelectedTab(selectedTab);
  };

    const tabonChange = (e) => {  
    SetDefaulttab({DisplayName: e.value.DisplayName, SortOrder: e.value.SortOrder});
    const updatevalue = defaultvalue?.map((item) => ({
      ...item,
      IsDefault: item.ColumnName === e.value.ColumnName,
    }));    
    Setdefaultvalue(updatevalue);    
  };
  const previouslyActiveTab = locationData.state === defaulttab ? defaulttab : "Contacts";
const buttonList=getAccessButton(investmentPremission,investorPremission);

  return (
    <>
      {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <>
          <TopBar label={paramValue==1? "Investors" : "Investment"} />
          <div id="content" className="asset-detail-screen">
            <BreadCrumbs Levels={Level} />
            <div className="container-fluid">
              <div className="container-fluid p-4 d-flex">
                <Col xs={2} md={1} lg={1}>
                  <Image
                    src={dataUri ? dataUri : SampleProfile}
                    rounded
                    style={{ width: "120px", height: "120px" }}
                    className="img-fluid"
                  />
                </Col>
                <Col xs={10} md={11} lg={11}>
                  <div className="col-lg-12 p-3">
                    <div className="row m-0">
                      <div className="col-md-3">
                        <div className="mb-0">
                          <span className="fw-medium custom-font-size">
                            {ContactsHeader.ContactName}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 p-3 d-flex">
                    <div className="col-md-3">
                      <div className="col-md-12 align-items-center  d-flex">
                        <div className="col-md-2">
                          <div className="mb-0">
                            <Badge
                              pill
                              bg={
                                ContactsHeader.IsActive === true
                                  ? "success"
                                  : "danger"
                              }
                              style={{ fontSize: "14px", fontWeight: "500" }}
                            >
                              {ContactsHeader.IsActive === true
                                ? "Active"
                                : "InActive"}
                            </Badge>
                          </div>
                        </div>
                        <div className="col-md-1 dot-divider"></div>
                        <div className="col-md-3">
                          <div className="mb-0">
                            <span className="contact-font">
                              {ContactsHeader.ContactInvestmentStatusName}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-1 dot-divider"></div>
                        <div className="col-md-3">
                          <div className="mb-0">
                            <span className="contact-font">
                              {ContactsHeader.ContactId}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="mb-0">
                            <i
                              className="fa-solid fa-pencil edit_icon"
                              onClick={() => isEditable && headerEditClick("Edit")}
                            ></i>
                           {paramValue != 2 && <>
                            <i
                              className="fa-solid fa-gear mx-2"
                              onClick={() => isEditable && headerEditClick("custom")}
                            ></i>
                           </>} 
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-9">
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="p-sm-btn mx-1"
                          disabled={!isEditable}
                          onClick={navigateToAddNew}
                        >
                          <i className="fa-solid fa-plus" /> New Account
                        </button>
                        <div>
                        <button
                          type="submit"
                          className="p-sm-btn mx-1"
                          disabled={!isEditable}
                          onMouseEnter={() => setIsContactHovered(true)}
                          onMouseLeave={() =>setIsContactHovered(false)}
                        >
                          <i className="fa-solid fa-plus" /> New Contact
                        </button>
                        {isContactHovered && <><HoverList buttonList={buttonList} isContact={"Contact"} setHoverState={setIsContactHovered}/></>}
                        </div>
                        <div>
                        <button
                          type="submit"
                          className="p-sm-btn mx-1"
                          disabled={!isEditable}
                          onMouseEnter={() => setIsCompanyHovered(true)}
                          onMouseLeave={() =>setIsCompanyHovered(false)}>
                          <i className="fa-solid fa-plus" /> New Company
                        </button>
                        {isCompanyHovered && <><HoverList buttonList={buttonList}   isContact={"Company"} setHoverState={setIsCompanyHovered}/></>}
</div>
                      </div>
                    </div>
                  </div>
                </Col>
              </div>
              <div className="p-4">
                <Tabs
                  activeKey={selectedTab}
                  id="uncontrolled-tab-example"
                    className="ms-3"               
                  onSelect={(key) => handleTabClick(key)}
                >
                  {visibleTabs.map((item, index) => (
                      item.ColumnName !== "Performance" && ( <Tab
                      key={index}
                       eventKey={item.ColumnName}
                      title={item.DisplayName}
                      onSelect={() => handleTabClick(item.ColumnName)}
                      disabled={
                        item.ColumnName === "Performance" ||
                          item.ColumnName === "AccountPermission" 
                          
                      }
                    >
                      <div className="p-3 bg-white life-science rounded px-0">
                        {selectedTab === item.ColumnName &&
                          (() => {                           
                            switch (item.ColumnName) {
                              case "Contacts":
                                return (
                                  <Contacts ContactDetails={ContactsHeader} />
                                    );
                                case "ClientProfile":
                                    return <ClientProfile />;
                              case "Accounts":
                                return <Account />;
                              case "Documents":
                                return <Documents />;
                              case "ClientReporting":
                                return <Reporting />;
                              case "Relationships":
                                return <Relationships />;
                              case "PortalAccess":
                                return <PortalAccess />;
                              case "Activities":
                                return <Activities/>;
                              case "Tasks":
                                  return <Tasks />;

                                default:
                                return null;
                            }
                                  })()}
                      </div>
                    </Tab>
                  )))}
                                      
                </Tabs>
              </div>
            </div>
          </div>
          <SBADrawer
            open={showDrawer}
            setOpen={setshowDrawer}
            close={false}
            title={showEditButton ? "Update Header" : "Customize View Settings"}
          >
            <div>
              {showEditButton && (
                <div>
                  <div className="mb-4">
                    <div>
                      <Col xs={2} md={1} lg={1}>
                        <Image
                          src={dataUri ? dataUri : SampleProfile}
                          rounded
                          style={{ width: "120px", height: "120px" }}
                        />
                      </Col>
                    </div>
                    <div>
                      <i
                        class="fa-solid fa-xmark"
                        onClick={handleDeleteImage}
                      ></i>
                    </div>
                  </div>
                  <div className="mb-4">
                    <input
                      id="fileInput"
                      type="file"
                      accept=".png, .jpg, .jpeg, image/*"
                      onChange={handleFileChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="mb-4">
                      <span className="fw-medium">Investment Status</span>
                      <div>
                        <SBADropDown
                          className="w-75"
                          data={investmentStatusData}
                          textField={"EnumName"}
                          valueField={"EnumValue"}
                          value={investmentStatusValue}
                          onChange={statusDataChange}
                          popupSettings={{ className: "modalDD" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-4">
                      <span className="fw-medium">User Status</span>
                      <div>
                        <label
                          className={`switch ${
                            ContactsHeader.IsActive ? "active" : "inactive"
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={isActive}
                            onChange={toggleSwitch}
                          />
                          <span
                            className={`slider round ${
                              isActive ? "bg-success" : "bg-danger"
                            }`}
                          ></span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4">
                    <button className="s-sm-btn mx-1" onClick={closeDrawer}>
                      Cancel
                    </button>
                    <button
                      className="p-sm-btn mx-1"
                      onClick={UpdateContactHeader}
                    >
                      Save
                    </button>
                  </div>
                </div>
              )}
              {showCustomButton && (
                <div>
                  <div className="row" style={{ marginTop: "60px" }}>
                    <div className="col-md-5">
                      <div
                        className="griddata ag-theme-alpine"
                        style={{ height: "35rem", width: "15rem" }}
                      >
                        <AgGridReact
                          columnDefs={MaincolDef}
                          rowData={defaultcol}
                          onRowDoubleClicked={MainRowDoubleClicked}
                          rowSelection={"single"}
                          ref={TotalTabs}
                          defaultColDef={{resizable:true}}
                        ></AgGridReact>
                      </div>
                    </div>

                    <div className="col-md-2 d-flex flex-column justify-content-center px-3">
                      <button className="p-sm-btn my-1" onClick={addTabs}>
                        <i class="fa-solid fa-arrow-right"></i>
                      </button>
                      <button className="p-sm-btn my-1" onClick={removeTabs}>
                        <i class="fa-solid fa-arrow-left"></i>
                      </button>
                    </div>

                    <div className="col-md-5">
                      <div
                        className="griddata ag-theme-alpine"
                        style={{ height: "35rem", width: "15rem" }}
                      >
                        <AgGridReact
                          columnDefs={selectcolDef}
                          rowData={selectedcol}
                          onRowDoubleClicked={selectedRowDoubleClicked}
                          rowSelection={"single"}
                          ref={selectedTabRef}
                          onRowDragEnd={onRowDragEnd}
                          rowDragManaged={true}
                          animateRows={true} 
                          defaultColDef={{
                          sortable: true,
                          filter: true,
                          resizable: true,
                           }}
                        ></AgGridReact>
                      </div>
                    </div>
                  </div>
                  <div className="row" style={{ marginTop: "40px" }}>
                    <span className="fw-medium">Default Tab: </span>
                    <div>
                      <SBADropDown
                        className="w-50"
                        data={visibleTabs}
                        textField={"DisplayName"}
                        valueField={"SortOrder"}
                        onChange={tabonChange}
                        popupSettings={{ className: "modalDD" }}
                        value={defaulttab}
                      />
                    </div>
                  </div>

                  <div className="mt-4">
                    <button className="s-sm-btn mx-1" onClick={closeDrawer}>
                      Cancel
                    </button>
                    <button className="p-sm-btn mx-1" onClick={Addsave}>
                      Save
                    </button>
                  </div>
                </div>
              )}
            </div>
          </SBADrawer>
        </>
      )}
      <ToastContainer />
    </>
  );
};

const HoverList=({buttonList,setHoverState,isContact})=>{
  const history = useNavigate();
  const handleItemClick = (item) => {
    if(isContact=="Contact")
    {
   if(item=="Investor")
   history(`${UrlPath.InvestorDetailsEdit}${0}?ContactTypeId=1`);
   else
   history(`${UrlPath.InvestorDetailsEdit}${0}?ContactTypeId=2`);
    }
    else
    {
      if(item=="Investor")
      history(`${UrlPath.CompanyDetailsEdit}${0}?ContactTypeId=1`);
      else
      history(`${UrlPath.CompanyDetailsEdit}${0}?ContactTypeId=2`);
    }
  };

  return <div className="list-of-items mx-1 text-center" style={{width:"150px"}} onMouseEnter={()=>{setHoverState(value=>true)}} onMouseLeave={()=>{setHoverState(value=>false)}}>
  {buttonList.map((item,index) => (
    <div className={index+1==buttonList.length ?  " "  : "border-bottom"}
      key={item}
      onClick={() =>handleItemClick(item)}
    >
      {item}
    </div>
  ))}
</div>
}
function getAccessButton(investment,investor){
  const output=[]
  if(investment)
  output.push("Investment");
  if(investor)
  output.push("Investor");
  return output;
}